import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box } from '@mui/material';

const Label = ({
  className,
  color = 'secondary',
  children,
  style,
  sx,
  ...rest
}) => {
  return (
    <Box
      component="span"
      className={className}
      style={style}
      sx={[
        (theme) => ({
          fontFamily: theme.typography.fontFamily,
          alignItems: 'center',
          borderRadius: '2px',
          display: 'inline-flex',
          flexGrow: 0,
          whiteSpace: 'nowrap',
          cursor: 'default',
          flexShrink: 0,
          fontSize: theme.typography.pxToRem(12),
          fontWeight: theme.typography.fontWeightMedium,
          height: 20,
          justifyContent: 'center',
          letterSpacing: 0.5,
          minWidth: 20,
          padding: theme.spacing(0.5, 1),
          textTransform: 'uppercase',
          color: theme.palette[color]?.main,
          backgroundColor: theme.palette[color]
            ? alpha(theme.palette[color].main, 0.08)
            : undefined,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'success',
  ]),
};

export default Label;
